import React from 'react';

const ProjectDrawingOfficeIffsIndex = React.lazy(() => import("./index"))
const NewProjectDrawingOfficeIffs = React.lazy(() => import("./new"))
const CompareProjectDrawingOfficeIffs = React.lazy(() => import("./compare"))
const EditProjectDrawingOfficeIffs = React.lazy(() => import("./edit"))
const ShowProjectDrawingOfficeIffs = React.lazy(() => import("./show"))

export default[
	{path:'/project/:project_id/drawing_office/iffs/:id/edit',component: EditProjectDrawingOfficeIffs,name:'Edit ProjectDrawingOfficeIff'},
	{path:'/project/:project_id/drawing_office/iffs/new',component: NewProjectDrawingOfficeIffs,name:'New ProjectDrawingOfficeIff'},
	{path:'/project/:project_id/drawing_office/iffs/compare',component: CompareProjectDrawingOfficeIffs,name:'Compare ProjectDrawingOfficeIffs'},
	{path:'/project/:project_id/drawing_office/iffs/:id',component: ShowProjectDrawingOfficeIffs,name:'ProjectDrawingOfficeIff'},
	{path:'/project/:project_id/drawing_office/iffs',component: ProjectDrawingOfficeIffsIndex,name:'ProjectDrawingOfficeIffs'},
]
